module.exports = __webpack_public_path__ + "static/media/20201219_112254_513_IMG_3347.c7db51b7.jpg";